<div class="progress-wrapper">
  <div class="progress-text">{{ totalTime | toHourMinute:true }}/{{ duration | toHourMinute:true }}</div>
  <mat-progress-bar mode="determinate" [value]="progress"></mat-progress-bar>
</div>
<div class="progress-total-hours" *ngIf="totalHoursToDo > 0">
  <span>
    Total training requirement: <b>{{ totalHoursToDo }}</b> hours
  </span>
</div>